import { connect } from '@client/decorators/common';
import { getSelectedProfile, getSelectedProfileFlat } from '@client/selectors/entities/users';
import type { RootState } from '@client/store';

interface WithUserOptions {
  readonly flatten?: boolean;
}

/**
 * Decorate a component with the current selected profile data
 */
export const withSelectedProfile = <TProps>(options?: WithUserOptions) => {
  const mapStateToProps = (state: RootState) => {
    const { flatten = false } = options;

    const profile = flatten ? getSelectedProfileFlat(state) : getSelectedProfile(state);

    return {
      profile,
    };
  };

  return (
    WrappedComponent: React.ElementType<TProps & ReturnType<typeof mapStateToProps>>,
  ) => connect(mapStateToProps)(WrappedComponent as any);
};
